export const showAnalyzeProgressBar = (fullFixelData) => {
  if (fullFixelData.state === "active") return false;
  return fullFixelData?.LAST_30_DAYS?.fixelStats && (parseInt(fullFixelData.LAST_30_DAYS.fixelStats.total) < 500 || fullFixelData.state === "calculating");
};
export const showPotentialRevenue = (fullFixelData) => {
  return fullFixelData?.plan?.state.toLowerCase() === "active" && fullFixelData.plan.type.toLowerCase() === "trial" && fullFixelData?.conversions?.potentialRevenue;
};
export const showFBIntegrationSuccessful = (fullFixelData) => {
  // After successful integration
  return fullFixelData.FBIntegrationStatus === "connected" && fullFixelData.code !== localStorage.getItem("alertedFBIntegrationSuccessful");
};
export const showIntegrationFailure = (fullFixelData) => {
  // After failed integration
  return fullFixelData.FBIntegrationStatus === "failed" && fullFixelData.code !== localStorage.getItem("alertedFBIntegrationFailure");
};
export const showTrialUnder7Days = (fullFixelData) => {
  // Trial days count is 7 or less
  return fullFixelData?.plan && !!fullFixelData.plan.trial_days_remaining && parseInt(fullFixelData.plan.trial_days_remaining) <= 7;
};
export const showTrialExpired = (fullFixelData) => {
  // Trial expired
  const planState = fullFixelData?.plan?.state?.toLowerCase();
  const trialDaysLeft = fullFixelData?.plan?.trial_days_remaining;
  const planType = fullFixelData?.plan?.type.toLowerCase();

  return planState === "expired" || (trialDaysLeft < 1 && planType === "trial");
};
export const showNoActivePlan = (fullFixelData) => {
  // after reinstall and no active paid plan
  const segmentState = fullFixelData?.state?.toLowerCase();
  const planState = fullFixelData?.plan?.state.toLowerCase();
  const planType = fullFixelData?.plan?.type?.toLowerCase();

  return planState === "terminated" || (segmentState === "terminated" && planType === "trial");
};
export const showPaymentCompleted = (fullFixelData) => {
  // new plan subscription completed
  const newCharge_id = fullFixelData.newChargeID;

  return newCharge_id && newCharge_id.toString() !== localStorage.getItem("alertedChargeID");
};
export const showPlanDowngrade = (fullFixelData) => {
  // new plan subscription completed - plan is lower then the prev
  // TODO how to check if new plan cheaper?
  // const newCharge_id = fullFixelData.newChargeID;

  // return newCharge_id && newCharge_id.toString() !== localStorage.getItem("alertedChargeID");
  return false;
};
export const showSegmentActive = (fullFixelData) => {
  // On first entrance after the segment is set to active (check if segment state changed from calc to active in the last week or msg was dismissed - saved to cookies)
  var weekAgo = new Date();
  weekAgo.setDate(weekAgo.getDate() - 7);
  return fullFixelData.state === "active" && fullFixelData.last_state_change > +weekAgo && fullFixelData.code !== localStorage.getItem("alertedSegmentActive");
};
export const showPlanCancelled = (fullFixelData) => {
  // plan was cancelled
  return true;
};
